<template>
  <div>
    <div v-if="stockTakeCountDialog === false">
      <v-toolbar flat color="white" pt-5 mt-5>
        <v-btn round color="primary" @click="addItem()">Add Stock Take</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Search"></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="stockTakes"
        item-key="id"
        :search="search"
        align-center
        style="cursor: pointer"
        disable-initial-sort
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td v-if="props.item.status === 'In Progress'" class="text-xs-center">
            <v-icon @click="editItem(props.item)">edit</v-icon>
            <v-icon @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td
            @click="
              fetchStockTakeItem(props.item.id);
              stockTakeCountDialog = true;
              activeInventoryTab = true;
              passiveInventoryTab = false;
            "
            v-else
            class="text-xs-center"
          ></td>
          <td
            @click="
              fetchStockTakeItem(props.item.id);
              stockTakeCountDialog = true;
              activeInventoryTab = true;
              passiveInventoryTab = false;
            "
            class="text-xs-center"
          >
            {{ formatDate(props.item.startDate) }}
          </td>
          <td
            @click="
              fetchStockTakeItem(props.item.id);
              stockTakeCountDialog = true;
              activeInventoryTab = true;
              passiveInventoryTab = false;
            "
            v-if="props.item.status === 'Complete'"
            class="text-xs-center"
          >
            <v-chip small class="white--text" color="green">Complete</v-chip>
          </td>
          <td
            @click="
              fetchStockTakeItem(props.item.id);
              stockTakeCountDialog = true;
              activeInventoryTab = true;
              passiveInventoryTab = false;
            "
            v-else
            class="text-xs-center"
          >
            <v-chip small class="white--text" color="orange"
              >In Progress</v-chip
            >
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>

      <v-dialog v-model="addStockTake" max-width="500px">
        <v-card flat color="white">
          <v-toolbar color="primary">
            <h1 class="headline white--text">ADD STOCK TAKE</h1>
          </v-toolbar>
          <v-card-text>
            <v-layout>
              <v-flex xs7>
                <v-menu>
                  <v-text-field
                    class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.startDate)"
                    slot="activator"
                    label="Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs5 mx-1>
                <v-select
                  :items="['Complete', 'In Progress']"
                  v-model="item.status"
                  label="Select Status"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                @click="(addStockTake = false), (item = {})"
                >Cancel</v-btn
              >
              <v-btn
                round
                color="primary"
                v-if="startDate && item.status"
                @click="saveStockTake"
                >Save</v-btn
              >
              <v-btn round color="primary" v-else disabled>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editStockTake" max-width="500px">
        <v-card flat color="white">
          <v-toolbar color="primary">
            <h1 class="headline white--text">EDIT STOCK TAKE</h1>
          </v-toolbar>
          <v-card-text>
            <v-layout>
              <v-flex xs7>
                <v-menu>
                  <v-text-field
                    class="text-xs-center pr-5 pl-3 pt-2"
                    :value="formatDate(this.startDate)"
                    slot="activator"
                    label="Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs5 mx-1>
                <v-select
                  :items="['Complete', 'In Progress']"
                  v-model="item.status"
                  label="Select Status"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                @click="(editStockTake = false), (item = {})"
                >Cancel</v-btn
              >
              <v-btn
                round
                color="primary"
                v-if="startDate && item.status"
                @click="saveEditedStockTake"
                >Save</v-btn
              >
              <v-btn round color="primary" v-else disabled>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-if="stockTakeCountDialog === true">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn flat @click="closeView()">Close</v-btn>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="
              activeInventoryTab = true;
              passiveInventoryTab = false;
              activeInventorySummaryDialog = false;
            "
            class="grey--text"
            flat
            round
            color="grey"
            >Active Inventory</v-tab
          >
          <v-tab
            @click="
              passiveInventoryTab = true;
              activeInventoryTab = false;
              activeInventorySummaryDialog = false;
            "
            class="grey--text"
            flat
            round
            color="grey"
            >Passive Inventory</v-tab
          >
        </v-tabs>
      </v-toolbar>

      <v-card flat v-if="activeInventoryTab === true">
        <v-toolbar flat color="white">
          <v-btn round color="primary" @click="addActiveStockItem()"
            >Add Stock Item</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="submitActiveCount()"
            >Submit</v-btn
          >
        </v-toolbar>
        <v-data-table
          :headers="activeStockTakeCountHeaders"
          class="elevation-1"
          :key="tableKey"
          :items="activeStockTakeItems"
          item-key="id"
          align-center
          style="cursor: pointer"
        >
          <template v-slot:items="props">
            <td
              v-if="
                props.item.stockTake.status === 'In Progress' &&
                !props.item.isVerified
              "
              class="text-xs-center"
            >
              <v-icon @click="deleteActiveInventoryItem(props.item)"
                >delete</v-icon
              >
            </td>
            <td
              @click="activeInventorySummary(props.item)"
              v-else
              class="text-xs-center"
            ></td>
            <td
              @click="activeInventorySummary(props.item)"
              v-if="props.item.deviceMakeModelId"
              class="text-xs-center"
            >
              {{ props.item.deviceMakeModel.name }}
            </td>
            <td
              @click="activeInventorySummary(props.item)"
              class="text-xs-center"
            >
              {{ props.item.currentQuantity }}
            </td>
            <td
              @click="activeInventorySummary(props.item)"
              class="text-xs-center"
            >
              {{ props.item.actualQuantity }}
            </td>
            <td
              @click="activeInventorySummary(props.item)"
              v-if="props.item.unaccounted > 0"
              class="text-xs-center"
            >
              <v-chip small class="white--text" color="red">{{
                props.item.unaccounted
              }}</v-chip>
            </td>
            <td
              @click="activeInventorySummary(props.item)"
              v-else
              class="text-xs-center"
            ></td>
            <td style="text-align: center">
              <br /><v-checkbox
                class="justify-center"
                color="primary"
                @change="checkVerifiedActive(props.item)"
                v-model="props.item.isVerified"
              ></v-checkbox>
            </td>

            <td
              :key="keyActive"
              @click="activeInventorySummary(props.item)"
              v-if="
                props.item.isVerified === true && props.item.verifiedByContactId
              "
              class="text-xs-center"
            >
              {{ props.item.verifiedByContact.name }}
              {{ props.item.verifiedByContact.surname }}
            </td>
            <td
              :key="keyActive"
              @click="activeInventorySummary(props.item)"
              v-else
              class="text-xs-center"
            ></td>
            <td
              :key="keyActive"
              @click="activeInventorySummary(props.item)"
              v-if="props.item.lastEditByContactId"
              class="text-xs-center"
            >
              {{ props.item.lastEditByContact.name }}
              {{ props.item.lastEditByContact.surname }}
            </td>
            <td
              :key="keyActive"
              @click="activeInventorySummary(props.item)"
              v-else
              class="text-xs-center"
            ></td>
          </template>
          <template v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of
            {{ props.itemsLength }}</template
          >
        </v-data-table>

        <v-dialog
          persistent
          v-model="addActiveInventoryDialog"
          max-width="800px"
        >
          <v-card>
            <v-toolbar flat color="primary">
              <h3 class="headline white--text">Attach Stock Item</h3>
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="white"
                @click="addActiveInventoryDialog = false"
                >X</v-btn
              >
            </v-toolbar>
            <v-card-text>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete
                    :items="warehouses"
                    label="Warehouse"
                    item-text="name"
                    item-value="id"
                    v-model="stockWarehouseId"
                  ></v-autocomplete>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex v-if="stockWarehouseId" xs6 mx-2>
                  <v-text-field
                    label="Search"
                    v-model="search"
                    clearable
                    append-icon="search"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                v-if="stockWarehouseId"
                :headers="deviceMakeModelHeaders"
                class="elevation-1"
                :items="deviceMakeModels"
                item-key="id"
                :search="search"
                align-center
                :loading="loadingActive"
                style="cursor: pointer"
                :rows-per-page-items="[10, 25, 50, 100]"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    <v-icon
                      @click="attachActiveInventory(props.item)"
                      color="primary"
                      >add_circle_outline</v-icon
                    >
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td
                    v-if="
                      props.item.deviceMakeId !== null &&
                      typeof props.item.deviceMake !== 'undefined'
                    "
                    class="text-xs-center"
                  >
                    {{ props.item.deviceMake.name }}
                  </td>
                  <td v-else class="text-xs-center"></td>
                  <td class="text-xs-center">
                    {{ props.item.deviceType.name }}
                  </td>
                </template>
                <template v-slot:pageText="props"
                  >Records {{ props.pageStart }} - {{ props.pageStop }} of
                  {{ props.itemsLength }}</template
                >
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
      <v-card flat v-if="passiveInventoryTab === true">
        <v-toolbar flat color="white">
          <v-btn round color="primary" @click="addStockItem()"
            >Add Stock Item</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="submitPassiveCount()"
            >Submit</v-btn
          >
        </v-toolbar>
        <v-data-table
          :headers="stockTakeCountHeaders"
          class="elevation-1"
          :items="passiveStockTakeItems"
          item-key="id"
          align-center
          style="cursor: pointer"
        >
          <template v-slot:items="props">
            <td
              v-if="
                props.item.stockTake.status === 'In Progress' &&
                !props.item.isVerified
              "
              class="text-xs-center"
            >
              <v-icon @click="deletePassiveEquipmentItem(props.item)"
                >delete</v-icon
              >
            </td>
            <td v-else class="text-xs-center"></td>
            <td class="text-xs-center">
              {{ props.item.passiveEquipment.stockItem.name }}
            </td>
            <td class="text-xs-center">{{ props.item.currentQuantity }}</td>
            <td v-if="!props.item.isVerified" class="text-xs-center">
              <v-text-field
                class="align-center justify-center"
                v-model="props.item.actualQuantity"
                @blur="setEditByContact(props.item)"
                type="number"
              ></v-text-field>
            </td>
            <td v-else class="text-xs-center">
              {{ props.item.actualQuantity }}
            </td>
            <td style="text-align: center">
              <br /><v-checkbox
                class="justify-center"
                color="primary"
                @change="checkVerifiedPassive(props.item)"
                v-model="props.item.isVerified"
              ></v-checkbox>
            </td>
            <td
              :key="keyPassive"
              v-if="
                props.item.isVerified === true && props.item.verifiedByContactId
              "
              class="text-xs-center"
            >
              {{ props.item.verifiedByContact.name }}
              {{ props.item.verifiedByContact.surname }}
            </td>
            <td :key="keyPassive" v-else class="text-xs-center"></td>
            <td
              :key="keyPassive"
              v-if="props.item.lastEditByContactId"
              class="text-xs-center"
            >
              {{ props.item.lastEditByContact.name }}
              {{ props.item.lastEditByContact.surname }}
            </td>
            <td :key="keyPassive" v-else class="text-xs-center"></td>
          </template>
          <template v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of
            {{ props.itemsLength }}</template
          >
        </v-data-table>

        <v-dialog
          persistent
          v-model="addPassiveEquipmentsDialog"
          max-width="800px"
        >
          <v-card>
            <v-toolbar flat color="primary">
              <h3 class="headline white--text">Attach Stock Item</h3>
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="white"
                @click="addPassiveEquipmentsDialog = false"
                >X</v-btn
              >
            </v-toolbar>
            <v-card-text>
              <v-layout>
                <v-flex xs4>
                  <v-autocomplete
                    :items="warehouses"
                    label="Warehouse"
                    item-text="name"
                    item-value="id"
                    v-model="passiveStockWarehouseId"
                  ></v-autocomplete>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex v-if="passiveStockWarehouseId" xs6 mx-2>
                  <v-text-field
                    label="Search"
                    v-model="search"
                    clearable
                    append-icon="search"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                v-if="passiveStockWarehouseId"
                :headers="passiveEquipmentHeaders"
                class="elevation-1"
                :items="passiveEquipments"
                item-key="id"
                :search="search"
                align-center
                style="cursor: pointer"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    <v-icon
                      @click="attachPassiveEquipment(props.item)"
                      color="primary"
                      >add_circle_outline</v-icon
                    >
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.stockItem.stockType.name }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.stockItem.name }}
                  </td>
                  <td class="text-xs-center">{{ props.item.quantity }}</td>
                </template>
                <template v-slot:pageText="props"
                  >Records {{ props.pageStart }} - {{ props.pageStop }} of
                  {{ props.itemsLength }}</template
                >
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
    <div v-if="activeInventorySummaryDialog === true">
      <v-toolbar flat color="white">
        <v-flex xs2>
          <h3 style="text-align: center" dark-grey--text>
            {{ stockWarehouseName }}
          </h3>
        </v-flex>
        <v-flex xs2>
          <h3 style="text-align: center">{{ currentModel }}</h3>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat @click="closeActiveInventorySummary()">Close</v-btn>
      </v-toolbar>
      <v-toolbar v-if="!verifiedItem" flat color="white">
        <v-layout>
          <v-flex xs4>
            <v-text-field
              label="Pon Mac"
              v-model="ponMac"
              :key="scanItemKey"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-switch v-model="autoAdd" label="Auto-Add"></v-switch>
          </v-flex>
          <v-flex xs1>
            <v-btn
              small
              v-if="autoAdd === false"
              color="primary"
              round
              @click="ponMacSubmit(ponMac)"
              >Scan</v-btn
            >
          </v-flex>
          <v-flex xs6></v-flex>
        </v-layout>
      </v-toolbar>
      <v-layout>
        <v-flex xs4>
          <h3 dark-grey--text>Initial Stock</h3>
          <v-data-table
            :headers="activeInStockSummaryHeaders"
            class="elevation-1"
            :items="activeInStockSummaryList"
            item-key="id"
            align-center
            style="cursor: pointer"
            :rows-per-page-items="[10, 25, 50, 100]"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.deviceId }}</td>
              <td class="text-xs-center">{{ props.item.ponMac }}</td>
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of
              {{ props.itemsLength }}</template
            >
          </v-data-table>
        </v-flex>
        <v-flex xs4>
          <h3 dark-grey--text>
            New Device <v-icon color="primary">add_circle_outline</v-icon>
          </h3>
          <v-data-table
            :headers="activeNewSummaryHeaders"
            class="elevation-1"
            :items="activeNewSummaryList"
            item-key="id"
            align-center
            style="cursor: pointer"
            :rows-per-page-items="[10, 25, 50, 100]"
          >
            <template v-slot:items="props">
              <td v-if="!verifiedItem" class="text-xs-center">
                <v-icon @click="deleteNewDevice(props.item)">delete</v-icon>
              </td>
              <td v-else class="text-xs-center"></td>
              <td class="text-xs-center">{{ props.item.ponMac }}</td>
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of
              {{ props.itemsLength }}</template
            >
          </v-data-table>
        </v-flex>
        <v-flex xs4>
          <h3 dark-grey--text>
            Verified Stock <v-icon color="primary">check_circle_outline</v-icon>
          </h3>
          <v-data-table
            :headers="activeVerifiedStockSummaryHeaders"
            class="elevation-1"
            :items="activeVerifiedInStockSummaryList"
            item-key="id"
            align-center
            style="cursor: pointer"
            :rows-per-page-items="[10, 25, 50, 100]"
          >
            <template v-slot:items="props">
              <td v-if="!verifiedItem" class="text-xs-center">
                <v-icon @click="deleteVerifiedDevice(props.item)"
                  >delete</v-icon
                >
              </td>
              <td v-else class="text-xs-center"></td>
              <td class="text-xs-center">{{ props.item.deviceId }}</td>
              <td class="text-xs-center">{{ props.item.ponMac }}</td>
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of
              {{ props.itemsLength }}</template
            >
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
  data() {
    return {
      tableKey: 0,
      currentModel: "",
      currentItemId: null,
      stockTakeItemId: null,
      activeStockTakeItems: [],
      passiveStockTakeItems: [],
      ponMac: "",
      scanItemKey: 0,
      stockWarehouseName: "",
      currentStockWarehouseId: null,
      autoAdd: true,
      activeVerifiedInStockSummaryList: [],
      warehouses: [],
      passiveStockWarehouseId: null,
      stockWarehouseId: null,
      deviceMakeModels: [],
      allDeviceStock: [],
      currentDeviceMakeModelId: null,
      activeNewSummaryList: [],
      activeInstalledSummaryList: [],
      activeInStockSummaryList: [],
      activeInventorySummaryDialog: false,
      loadingActive: false,
      activeInventory: [],
      activeStockTakeCounts: [],
      activeInventoryTab: false,
      passiveInventoryTab: false,
      submitList: [],
      currentStockTakeId: null,
      addActiveInventoryDialog: false,
      addPassiveEquipmentsDialog: false,
      stockTakeCounts: [],
      stockTakeCountDialog: false,
      pagination: {
        descending: true,
        sortBy: "startDate",
      },
      startDate: null,
      stockTakes: [],
      addStockTake: false,
      editStockTake: false,
      search: "",
      item: {},
      activeNewSummaryHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
      ],
      activeVerifiedStockSummaryHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Device Id",
          align: "center",
          value: "id",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
      ],
      activeInStockSummaryHeaders: [
        {
          text: "Device Id",
          align: "center",
          value: "id",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
      ],
      passiveEquipmentPagination: {
        descending: true,
        sortBy: "createdAt",
      },
      activeStockTakeCountHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Device Make Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "Current Quantity",
          align: "center",
          value: "activeInstock",
        },
        {
          text: "Actual Quantity",
          align: "center",
          value: "activeActualInStock",
        },
        {
          text: "Unaccounted",
          align: "center",
          value: "unaccounted",
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified",
        },
        {
          text: "Verified By",
          align: "center",
          value: "verifiedByContactId",
        },
        {
          text: "Last Edit By",
          align: "center",
          value: "lastEditByContactId",
        },
      ],
      deviceMakeModelHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Device Make",
          align: "center",
          value: "deviceMake.name",
        },
        {
          text: "Device Type",
          align: "center",
          value: "deviceType.name",
        },
      ],
      passiveEquipmentHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "stockItem.stockType.name",
        },
        {
          text: "Item",
          align: "center",
          value: "stockItem.name",
        },
        {
          text: "Quantity",
          align: "center",
          value: "quantity",
        },
      ],
      stockTakeCountHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Passive Equipment",
          align: "center",
          value: "passiveEquipment.stockItem.name",
        },
        {
          text: "Current Quantity",
          align: "center",
          value: "passiveEquipment.quantity",
        },
        {
          text: "Actual Quantity",
          align: "center",
          value: "actualQuantity",
          width: "1%",
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified",
        },
        {
          text: "Verified By",
          align: "center",
          value: "verifiedByContactId",
        },
        {
          text: "Last Edit By",
          align: "center",
          value: "lastEditByContactId",
        },
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Start Date",
          align: "center",
          value: "startDate",
        },
        {
          text: "Status",
          align: "center",
          value: "status",
        },
      ],
      keyPassive: 0,
      keyActive: 0,
      verifiedItem: true,
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    ponMac(value) {
      if (this.autoAdd == true && value != "" && value != null) {
        this.ponMac=value
         setTimeout(()=>{          
        if (
          this.ponMac!=""
        ) {
        this.ponMacSubmit(this.ponMac)
         this.ponMac = "";
        } 
        }, 1000);
        
      }
    },
  },
  methods: {
    deleteNewDevice(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        Api()
          .put("/stockTakeCount/" + item.id, {
            isActive: false,
            isDeleted: true,
          })
          .then((response) => {
            let find = this.activeNewSummaryList.find((x) => x.id == item.id);
            let index = this.activeNewSummaryList.indexOf(find);
            this.activeNewSummaryList.splice(index, 1);
          });
      }
    },
    deleteVerifiedDevice(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        Api()
          .put("/stockTakeCount/" + item.id, {
            isVerifiedInStock: false,
            currentQuantity: 1,
            actualQuantity: 1,
          })
          .then((response) => {
            let find = this.activeVerifiedInStockSummaryList.find(
              (x) => x.id == item.id
            );
            let index = this.activeVerifiedInStockSummaryList.indexOf(find);
            this.activeVerifiedInStockSummaryList.splice(index, 1);
            this.activeInStockSummaryList.push(find);
          });
      }
    },
    checkVerifiedActive(item) {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        let index = this.activeStockTakeItems.findIndex(
          (x) => x.id === item.id
        );
        this.activeStockTakeItems[
          index
        ].verifiedByContact = this.$store.state.user;
        this.activeStockTakeItems[
          index
        ].verifiedByContactId = this.$store.state.user.id;
        this.keyActive++;
        Api().put("/stockTakeItem/" + item.id, {
          verifiedByContactId: this.$store.state.user.id,
          isVerified: true,
        });
      }
    },
    checkVerifiedPassive(item) {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        let index = this.passiveStockTakeItems.findIndex(
          (x) => x.id === item.id
        );
        this.passiveStockTakeItems[
          index
        ].verifiedByContact = this.$store.state.user;
        this.passiveStockTakeItems[
          index
        ].verifiedByContactId = this.$store.state.user.id;
        this.keyPassive++;
        Api().put("/stockTakeItem/" + item.id, {
          verifiedByContactId: this.$store.state.user.id,
          isVerified: true,
        });
      }
    },
    setEditByContact(item) {
      let index = this.passiveStockTakeItems.findIndex((x) => x.id === item.id);
      this.passiveStockTakeItems[
        index
      ].lastEditByContact = this.$store.state.user;
      this.passiveStockTakeItems[
        index
      ].lastEditByContactId = this.$store.state.user.id;
      this.keyPassive++;
      Api().put("/stockTakeItem/" + item.id, {
        actualQuantity: item.actualQuantity,
        lastEditByContactId: this.$store.state.user.id,
      });
    },
    async ponMacSubmit(ponMac) {
      Api().put("/stockTakeItem/" + this.currentItemId, {
        lastEditByContactId: this.$store.state.user.id,
      });
      await Api()
        .get("/devices/getByPonMac/" + ponMac)
        .then(async (response) => {
          let inStock = await this.activeInStockSummaryList.filter(function (
            el
          ) {
            return el.ponMac === ponMac;
          });
          if (inStock.length !== 0) {
            this.activeVerifiedInStockSummaryList.push({
              deviceId: response.data.id,
              isVerifiedInStock: true,
              actualQuantity: inStock[0].actualQuantity,
              createdAt: inStock[0].createdAt,
              currentQuantity: inStock[0].currentQuantity,
              deviceMakeModelId: inStock[0].deviceMakeModelId,
              id: inStock[0].id,
              isActive: inStock[0].isActive,
              isDeleted: inStock[0].isDeleted,
              isVerified: inStock[0].isVerified,
              lastEditByContactId: inStock[0].lastEditByContactId,
              organisationId: inStock[0].organisationId,
              passiveEquipmentId: inStock[0].passiveEquipmentId,
              ponMac: inStock[0].ponMac,
              stockTakeId: inStock[0].stockTakeId,
              updatedAt: inStock[0].updatedAt,
              verifiedByContactId: inStock[0].verifiedByContactId,
            });
            let index = this.activeInStockSummaryList.find(
              (x) => x.ponMac == ponMac
            );
            this.activeInStockSummaryList.splice(index, 1);
            Api()
              .put("/stockTakeCount/" + inStock[0].id, {
                isVerifiedInStock: true,
              })
              .then((response) => {
                this.ponMac = "";
                this.fetchStockTakeItem(this.currentStockTakeId);
              });
          } else {
            Api()
              .post("/stockTakeCount", {
                currentQuantity: 0,
                actualQuantity: 1,
                stockWarehouseId: this.currentStockWarehouseId,
                deviceMakeModelId: this.currentDeviceMakeModelId,
                ponMac: ponMac,
                stockTakeId: this.currentStockTakeId,
                isActive: true,
                isDeleted: false,
              })
              .then((response) => {
                this.ponMac = "";
                this.fetchActiveNewStock();
                this.fetchStockTakeItem(this.currentStockTakeId);
              });
          }
          this.scanItemKey++;
        });
    },
    initialize() {
      this.fetchStockTake();
      this.fetchDeviceMakeModels();
      this.getWarehouses();
    },
    getWarehouses() {
      Api()
        .get("/stockWarehouse")
        .then((response) => {
          this.warehouses = response.data;
        });
    },
    fetchDeviceMakeModels() {
      Api()
        .get("/deviceMakeModels/active")
        .then((response) => {
          this.deviceMakeModels = response.data;
        });
    },

    fetchActiveNewStock() {
      Api()
        .get(
          "/stockTakeCount/activeNewStock/" +
            this.currentDeviceMakeModelId +
            "/" +
            this.currentStockTakeId
        )
        .then((response) => {
          this.activeNewSummaryList = response.data;
        });
    },
    activeInventorySummary(item) {
      Api()
        .get("/stockTakeItem/" + item.id)
        .then((response) => {
          this.verifiedItem = response.data.isVerified;
        });
      this.currentModel = item.deviceMakeModel.name;
      this.currentDeviceMakeModelId = item.deviceMakeModelId;
      this.currentStockWarehouseId = item.stockWarehouseId;
      this.currentItemId = item.id;

      Api()
        .get(
          "/stockTakeCount/activeInStock/" +
            item.deviceMakeModelId +
            "/" +
            this.currentStockWarehouseId +
            "/" +
            item.id
        )
        .then(async (response) => {
          this.activeInStockSummaryList = [];
          await response.data.map(async (x) => {
            await Api()
              .get("/devices/getByPonMac/" + x.ponMac)
              .then((response) => {
                this.activeInStockSummaryList.push({
                  id: x.id,
                  isVerifiedInStock: x.isVerifiedInStock,
                  currentQuantity: x.currentQuantity,
                  actualQuantity: x.actualQuantity,
                  stockWarehouseId: x.stockWarehouseId,
                  deviceMakeModelId: x.deviceMakeModelId,
                  ponMac: x.ponMac,
                  stockTakeId: x.stockTakeId,
                  isActive: x.isActive,
                  isDeleted: x.isDeleted,
                  deviceId: response.data.id,
                });
              });
          });
          Api()
            .get("/stockWarehouse/basic/" + this.currentStockWarehouseId)
            .then((response) => {
              this.stockWarehouseName = response.data.name;
            });
          Api()
            .get(
              "/stockTakeCount/activeNewStock/" +
                item.deviceMakeModelId +
                "/" +
                this.currentStockTakeId
            )
            .then((response) => {
              this.activeNewSummaryList = response.data;
              Api()
                .get(
                  "/stockTakeCount/activeVerifiedInStock/" +
                    item.deviceMakeModelId +
                    "/" +
                    this.currentStockWarehouseId +
                    "/" +
                    item.id
                )
                .then(async (response) => {
                  this.activeVerifiedInStockSummaryList = [];
                  await response.data.map(async (x) => {
                    await Api()
                      .get("/devices/getByPonMac/" + x.ponMac)
                      .then((response) => {
                        this.activeVerifiedInStockSummaryList.push({
                          id: x.id,
                          isVerifiedInStock: x.isVerifiedInStock,
                          currentQuantity: x.currentQuantity,
                          actualQuantity: x.actualQuantity,
                          stockWarehouseId: x.stockWarehouseId,
                          deviceMakeModelId: x.deviceMakeModelId,
                          ponMac: x.ponMac,
                          stockTakeId: x.stockTakeId,
                          isActive: x.isActive,
                          isDeleted: x.isDeleted,
                          deviceId: response.data.id,
                        });
                      });
                  });
                  this.activeInventorySummaryDialog = true;
                  this.activeInventoryTab = false;
                });
            });
        });
    },
    closeActiveInventorySummary() {
      Api()
        .put("/stockTakeItem/" + this.currentItemId, {
          actualQuantity:
            this.activeVerifiedInStockSummaryList.length +
            this.activeNewSummaryList.length,
        })
        .then((response) => {
          this.fetchStockTakeItem(this.currentStockTakeId);
          this.activeInventorySummaryDialog = false;
          this.activeInventoryTab = true;
        });
    },
    addStockItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .get("/passiveEquipment")
          .then((response) => {
            this.passiveEquipments = response.data;
            this.addPassiveEquipmentsDialog = true;
          });
      }
    },
    addActiveStockItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.loadingActive = true;
        this.addActiveInventoryDialog = true;
        Api()
          .get("/devices/inventory")
          .then((response) => {
            this.activeInventory = response.data;
            this.loadingActive = false;
          });
      }
    },
    attachPassiveEquipment(item) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/stockTakeItem", {
            isVerifiedInStock: false,
            organisationId: this.$store.state.currentOrg.org.id,
            currentQuantity: item.quantity,
            passiveEquipmentId: item.id,
            stockWarehouseId: this.passiveStockWarehouseId,
            stockTakeId: this.currentStockTakeId,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            Api()
              .post("/stockTakeCount", {
                currentQuantity: item.quantity,
                passiveEquipmentId: item.id,
                stockTakeItemId: response.data.id,
                stockTakeId: this.currentStockTakeId,
                stockWarehouseId: this.passiveStockWarehouseId,
                isActive: true,
                isDeleted: false,
              })
              .then((response) => {
                this.fetchStockTakeItem(this.currentStockTakeId);
                this.addPassiveEquipmentsDialog = false;
              });
          });
      }
    },
    async attachActiveInventory(item) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        let post = [];
        await Api()
          .get("/devices/byModel/" + item.id)
          .then(async (response) => {
            await Api()
              .post("/stockTakeItem", {
                isVerifiedInStock: false,
                organisationId: this.$store.state.currentOrg.org.id,
                currentQuantity: response.data.length,
                actualQuantity: 0,
                deviceMakeModelId: item.id,
                stockWarehouseId: this.stockWarehouseId,
                stockTakeId: this.currentStockTakeId,
                isActive: true,
                isDeleted: false,
              })
              .then((response) => {
                this.stockTakeItemId = response.data.id;
              });
            for (let i = 0; i < response.data.length; i++) {
              await post.push({
                isVerifiedInStock: false,
                organisationId: response.data[i].organisationId,
                currentQuantity: 1,
                actualQuantity: 1,
                deviceMakeModelId: item.id,
                stockWarehouseId: this.stockWarehouseId,
                ponMac: response.data[i].ponMac,
                stockTakeId: this.currentStockTakeId,
                stockTakeItemId: this.stockTakeItemId,
                isActive: true,
                isDeleted: false,
              });
            }
          })
          .then(async (response) => {
            await Api()
              .post("/bulkCreateStockTakeCount", {
                batch: post,
              })
              .then((response) => {
                this.fetchStockTakeItem(this.currentStockTakeId);
                this.addActiveInventoryDialog = false;
              });
          });
      }
    },
    fetchStockTakeItem(stockTakeId) {
      this.currentStockTakeId = stockTakeId;
      Api()
        .get("/stockTakeItem/passive/byStockTake/" + stockTakeId)
        .then((response) => {
          this.passiveStockTakeItems = response.data;
        });
      Api()
        .get("/stockTakeItem/active/byStockTake/" + stockTakeId)
        .then((response) => {
          this.activeStockTakeItems = response.data;
          this.activeStockTakeItems.map((x) => {
            Api()
              .get(
                "/stockTakeCount/activeInStock/" +
                  x.deviceMakeModelId +
                  "/" +
                  x.stockWarehouseId +
                  "/" +
                  x.id
              )
              .then(async (response) => {
                x.unaccounted = response.data.length;
                this.tableKey++;
              });
          });
        });
    },
    async submitActiveCount() {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        let updateCountTable = [];
        let updateItems = [];
        let updateInStockDevices = [];
        let updateVerifiedInStockDevices = [];
        let updateNewDevices = [];
        let warehouseId = null;
        for (let k = 0; k < this.activeStockTakeItems.length; k++) {
          warehouseId = this.activeStockTakeItems[k].stockWarehouseId;
          if (this.activeStockTakeItems[k].isVerified === true) {
            for (let j = 0; j < this.activeInStockSummaryList.length; j++) {
              updateInStockDevices.push({
                id: this.activeInStockSummaryList[j].deviceId,
                inStock: false,
              });
            }
            for (
              let j = 0;
              j < this.activeVerifiedInStockSummaryList.length;
              j++
            ) {
              updateVerifiedInStockDevices.push({
                id: this.activeVerifiedInStockSummaryList[j].deviceId,
                inStock: true,
                stockWarehouseId: warehouseId,
                locationId: null,
                locationNetworkId: null,
                locationNodeId: null,
                switchingCentreId: null,
              });
            }
            for (let j = 0; j < this.activeNewSummaryList.length; j++) {
              updateNewDevices.push({
                ponMac: this.activeNewSummaryList[j].ponMac,
                deviceMakeModelId: this.activeNewSummaryList[j]
                  .deviceMakeModelId,
                inStock: true,
                stockWarehouseId: warehouseId,
                locationId: null,
                locationNetworkId: null,
                locationNodeId: null,
                switchingCentreId: null,
              });
            }
            await Api().post("/bulkUpdateDevicesInStock", {
              batch: updateInStockDevices,
            });
            await Api().post("/bulkUpdateDevicesInStock", {
              batch: updateVerifiedInStockDevices,
            });
            await Api().post("/bulkCreateDevices", {
              batch: updateNewDevices,
              stockWarehouseId: warehouseId,
            });
          }
        }

        // Api()
        //   .put("/stockTake/" + this.currentStockTakeId, {
        //     status: 'Complete'
        //   }).then(response=>{
        //      this.fetchStockTakeItem(this.currentStockTakeId)
        //   })
        this.fetchStockTakeItem(this.currentStockTakeId);
        this.closeActiveInventorySummary()
      }
    },
    submitPassiveCount() {
      if (this.authAdmin(this.$store.state.currentRoute)) {
        let updateEquipment = [];
        for (let k = 0; k < this.passiveStockTakeItems.length; k++) {
          if (this.passiveStockTakeItems[k].isVerified === true) {
            updateEquipment.push({
              id: this.passiveStockTakeItems[k].passiveEquipmentId,
              quantity: this.passiveStockTakeItems[k].actualQuantity,
              stockItemId: this.passiveStockTakeItems[k].passiveEquipment
                .stockItem.id,
              stockWarehouseId: this.passiveStockTakeItems[k].passiveEquipment
                .stockWarehouse.id,
            });
          }
        }

        Api()
          .post("/bulkUpdatePassiveEquipment", {
            batch: updateEquipment,
          })
          .then((response) => {
            this.fetchStockTakeItem(this.currentStockTakeId);
            this.closeView()
          });
      }
    },

    closeView() {
      this.stockTakeCountDialog = false;
      this.activeInventoryTab = false;
      this.passiveInventoryTab = false;
      this.activeInventorySummaryDialog = false;
    },
    fetchStockTake() {
      Api()
        .get("/stockTake")
        .then((response) => {
          this.stockTakes = response.data;
        });
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.item = Object.assign({}, item);
        this.startDate = this.item.startDate;
        this.editStockTake = true;
      }
    },
    deleteItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to delete this Stock Take?") &&
          Api()
            .put("/stockTake/" + item.id, {
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              this.fetchStockTake();
            });
      }
    },
    deletePassiveEquipmentItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to delete this Stock Take Item?"
        ) &&
          Api()
            .put("/stockTakeItem/byEquipmentId/" + item.passiveEquipmentId, {
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              Api().put("/stockTakeCount/byItem/" + item.id, {
                isActive: false,
                isDeleted: true,
              });
              this.fetchStockTakeItem(this.currentStockTakeId);
            });
      }
    },
    deleteActiveInventoryItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to delete this Stock Take Item?"
        ) &&
          Api()
            .put("/stockTakeItem/byModel/" + item.deviceMakeModelId, {
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              Api().put("/stockTakeCount/byItem/" + item.id, {
                isActive: false,
                isDeleted: true,
              });
              this.fetchStockTakeItem(this.currentStockTakeId);
            });
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.startDate = null;
        this.addStockTake = true;
      }
    },
    saveStockTake() {
      Api()
        .post("/stockTake", {
          startDate: this.startDate,
          status: this.item.status,
          isDelete: false,
        })
        .then((response) => {
          this.fetchStockTake();
          this.addStockTake = false;
          this.item = {};
        });
    },
    saveEditedStockTake() {
      Api()
        .put("/stockTake/" + this.item.id, {
          startDate: this.startDate,
          status: this.item.status,
          isActive: true,
          isDelete: false,
        })
        .then((response) => {
          this.fetchStockTake();
          this.editStockTake = false;
          this.item = {};
        });
    },
  },
};
</script>

<style>
</style>